<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">แบบฟอร์มพิจารณา</div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 190px">
            <div>สถานะ</div>
            <SelectBox placeholder="สถานะ" hide-details></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-inner-icon="search"
            ></TextField>
          </div>
        </div>
        <div class="d-flex justify-end">
          <v-btn
            width="135"
            height="35"
            depressed
            rounded
            dark
            color="#D9D9D9"
            class="btn-create-consider"
            @click="onCreateForm"
          >
            <span class="font-14 font-w-700 font-ch">สร้างแบบฟอร์ม</span>
          </v-btn>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
          v-for="(item, i) in tableHeader"
          :key="i"
          :style="{ width: item.width, textAlign: item.align }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <!-- <ConsiderFormItem
          v-for="(item, i) in plans"
          :key="i"
          :item="item"
          :index="i"
          :headers="tableHeader"
        ></ConsiderFormItem> -->

        <div
          v-for="(item, i) in items"
          :key="i"
          class="d-flex justify-space-between align-center font-ch font-14 font-w-500 row_card"
        >
          <div
            :style="{
              width: tableHeader[0].width,
              textAlign: tableHeader[0].align,
              height: '73px',
            }"
            class="d-flex justify-lg-space-between align-center"
          >
            <div
              class="div_status"
              :style="
                item.status == 'active'
                  ? { backgroundColor: '#5CB844' }
                  : { backgroundColor: '#B1B1B1' }
              "
            ></div>

            <div class="d-flex justify-center align-center" style="width: 100%">
              <!-- btn edit -->
              <v-btn
                width="15"
                height="15"
                depressed
                icon
                class="mx-2"
                dark
                color="#D9D9D9"
                @click="onEditForm(item)"
              >
                <v-icon style="font-size: 20px" color="#F15A29">
                  mdi-pencil
                </v-icon>
              </v-btn>

              <!-- btn delete -->
              <v-btn
                width="15"
                height="15"
                depressed
                class="mx-2"
                icon
                dark
                color="#D9D9D9"
                @click="onDeleteForm(item)"
              >
                <v-icon style="font-size: 20px" color="#B1B1B1">
                  mdi-delete
                </v-icon>
              </v-btn>
            </div>
          </div>
          <div
            :style="{
              width: tableHeader[1].width,
              textAlign: tableHeader[1].align,
            }"
          >
            {{ (paginate.current_page - 1) * paginate.per_page + i + 1 }}
          </div>
          <div
            :style="{
              width: tableHeader[2].width,
              textAlign: tableHeader[2].align,
            }"
          >
            {{ item.year }}
          </div>
          <div
            :style="{
              width: tableHeader[3].width,
              textAlign: tableHeader[3].align,
            }"
          >
            {{ item.plan_name }}
          </div>
          <div
            :style="{
              width: tableHeader[4].width,
              textAlign: tableHeader[4].align,
            }"
          >
            <span
              :style="
                item.status == 'active'
                  ? { color: '#5CB844' }
                  : { color: '#464647' }
              "
            >
              {{ item.status == "active" ? "ใช้งานอยู่" : "ปิดใช้งาน" }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <v-pagination
      class="mt-6"
      v-model="paginate.current_page"
      :length="paginate.last_page"
      color="#DE7033"
      @input="getConsiderFormList"
    ></v-pagination>

    <!-- <pre>
      {{ items }}
    </pre> -->
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SelectBox from "../../components/input/SelectBox";
// import ConsiderFormItem from "../../components/ConsiderFormItem";
import { mapState } from "vuex";
import Service from "../../services";

export default {
  name: "ConsiderFormList",
  components: {
    TextField,
    SelectBox,
    // ConsiderFormItem,
  },
  data() {
    return {
      tableHeader: [
        {
          name: "",
          width: "10%",
          align: "center",
        },
        {
          name: "ลำดับ",
          width: "10%",
          align: "center",
        },
        {
          name: "ปี งปม.",
          width: "10%",
          align: "center",
        },
        {
          name: "ชื่อแบบฟอร์ม",
          width: "50%",
          align: "left",
        },
        {
          name: "สถานะ",
          width: "20%",
          align: "center",
        },
      ],
      items: [],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
      status: [],
      search: "",
    };
  },
  created() {
    this.getConsiderFormList(1);
  },
  computed: {
    ...mapState({
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
    }),
  },
  methods: {
    async getConsiderFormList(page) {
      console.log(page);
      const res = await this.$apiFire("Consider/index", {
        page: page,
        search: this.search,
        status: this.status,
      });
      console.log(res);
      if (res.data) {
        this.items = res.data.data;
        this.paginate = {
          total: res.data.total,
          per_page: res.data.per_page,
          current_page: res.data.current_page,
          last_page: res.data.last_page,
        };
      }
    },
    onCreateForm() {
      this.$router.push({
        name: "ConsiderForm",
      });
    },
    onEditForm(item) {
      this.$router.push("/consider-form/form/" + item.id);
    },
    onDeleteForm(item) {
      console.log(item);
      // sweetalert confirm
      this.$swal({
        title: "Do you want to delete this?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#FD0C0C",
      }).then((result) => {
        if (result.isConfirmed) {
          Service.Consider.delete(item.id)
            .then((res) => {
              this.$swal("Deleted!", "", "success");
              this.getConsiderFormList(this.paginate.current_page);
            })
            .catch((err) => {
              this.$swal("Error!", "", "error");
            });
        }
      });
    },
    onViewForm(item) {
      this.$router.push({
        name: "ConsiderFormEdit",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  padding: 0 33px 0 36px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-create-consider {
  background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  height: 30px;
  padding: 0px 10px;
}
.row_card {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  height: 73px;
}
.div_status {
  background: #b1b1b1;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px 0px 0px 20px;
  width: 19px;
  height: 73px;
}
</style>
